import React, { useState,useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/styles";
import {Grid, Card, CardHeader, IconButton, Chip, Paper, Tooltip, Box, Typography, Tab, Tabs, useTheme } from "@material-ui/core";

import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarRateIcon from '@material-ui/icons/StarRate';
import VideoCallIcon from '@material-ui/icons/VideoCall';
import GetAppIcon from '@material-ui/icons/GetApp';
// import Stepper from '@material-ui/core/Stepper';
// import Step from '@material-ui/core/Step';
// import StepButton from '@material-ui/core/StepButton';

// import StepLabel from '@material-ui/core/StepLabel';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import SubPanelListView from "../SubPanel/SubPanelListView";
import useStyles from "./styles";
import { pathOr, clone } from "ramda";

import AORReportDetail from "../AOR_Reports";

import {
  addToFavouriteRecord,
} from "../../store/actions/dashboard.actions";
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import CallIcon from '@material-ui/icons/Call';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import EmailIcon from '@material-ui/icons/Email';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import {
  TabPanel as DetailViewTab,
  ControlledAccordions as DetailViewPanel,
  BPM
} from "../";
import { MoreActionButton } from "../FormComponents";

import QuickCreate from "./components/quickCreate/quickCreate";
import { QuickComposeEmail } from "../Emails/components";
import { getEmailCreateView } from "../../store/actions/emails.actions";
import { textEllipsis } from '../../common/utils';

const useStylesSpeedDialAction = makeStyles((theme) => ({
  staticTooltipLabel: {
    minWidth: '145px',
    fontSize: '0.875rem',
    backgroundColor: (theme.rightBarButtons.background + ' !important'),
    color: theme.rightBarButtons.text,
    border: '1px solid ' + theme.rightBarButtons.text

  },
  fab: {
    backgroundColor: (theme.rightBarButtons.background + ' !important'),
    color: theme.rightBarButtons.text,
    border: '1px solid ' + theme.rightBarButtons.text
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2} style={{ paddingTop: 5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const handleCheck = (data, val, module = '') => {
  // if (module === 'AOS_Quotes') {
  //   return data.some((item) => val === item.type);
  // } else {
  //   return false;
  // }
return false;

};


export default function DetailView({
  data,
  subpanels,
  module,
  recordId,
  recordName,
  recordInfo,
  highlightRow,
  is_fav,
  actionButtons,
  setIsSubpanelUpdated,
  value,
  setValue

}) {
  // console.log("Data--->", subpanels);
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  // const [value, setValue] = React.useState(0);
  // const theme = useTheme();
  const moduleLabel = useSelector((state) => pathOr("", [module, "label"], state.dashboard.sidebarLinks.attributes));
  // const moduleIcon = useSelector((state) => pathOr("", [module, "icon"], state.dashboard.sidebarLinks.attributes));
  const { config } = useSelector((state) => state.config,);
  const { emailCreateViewLoading } = useSelector((state) => state.emails);
 
  const reportData = clone(data);
  data = pathOr([], ["data", "templateMeta", "data"], data);
  const statusBarData = pathOr([], ["data", "templateMeta", "recordInfo", "statusBar"], reportData);
  const statusBackground = pathOr([],["fields_background", module],config);
  // let statusField = Object.keys(statusBackground);
  let option = (statusBarData.options) ? Object.keys(statusBarData.options).find(key => statusBarData.options[key] === statusBarData.value) : '';
  // let optionBgColor = `${pathOr("", ['status', option, "background_color"], statusBackground)}`;
  // console.log("optionBgColor",option);
  var isTab = handleCheck(data, "tab", module);
  const [direction] = useState('up');
  const [openDashboardActions, setOpenDashboardActions] = useState(false);
  const [openQuickCreateDialog, setOpenQuickCreateDialog] = useState(false);
  const [whichQuickCreate, setWhichQuickCreate] = useState(null);
  const [emailModalVisible, setEmailModalVisible] = useState(false);
  const [emailModal, setEmailModal] = useState({visible:false,to:""});

  const classesSpeedDialAction = useStylesSpeedDialAction();
  //var isTab = false;
  const [is_favs, setIsFav] = useState(is_fav);

const configurator = pathOr([], ['hideShowConf', 'appConfigurator', module], config);
const {disabledAlways,hiddenAlways,...rest}= configurator;
let [hiddenAll, setHiddenAll] = useState({hidden:hiddenAlways || [],disabled:disabledAlways || []});

useEffect(
  () => {
    let initialState = [];
    let fieldState = [];
    Object.keys(data).map((row) => {
      setValues(data[row].attributes, initialState, fieldState);
      data[row].panels &&
        data[row].panels.map((panelRow) => {
          setValues(panelRow.attributes, initialState, fieldState);
        });
    });
  },
  [data]
);

const setValues = (attributes, initialState, fieldState) => {
  attributes.map((rowField) => {
    rowField.map((field) => {
      if(field.type==='enum' || field.type==='dynamicenum'){
       
       let getOption=Object.keys(field.options)[Object.values(field.options).indexOf(field.value)];
       setDependencyHidden(field,getOption);
      }else{
        setDependencyHidden(field,field.value);	
      }
    
     
    });
  });
};

const setDependencyHidden = (field,value) =>{
  if(rest){
		const innerHiddenAlways = Object.values(rest).find(o =>o.fieldsSel[0] ===field.name);
		const newCaptureCond = pathOr([], ['condition'], innerHiddenAlways);

		const innCond = Object.values(newCaptureCond).find(o => o.field_value[0] === field.options ? field.options[value] : field.type==='bool'?value===0?'false':value?'true':'false':value);
		const hiddField = pathOr([], ['hiddenField'], innCond);

  
		if(field.type==='bool' ){
		console.log("fieldvalue",value)
			if (value==='0' || value===false) {
				let array3 = [...hiddenAll['hidden'], ...hiddField];
				array3 = array3.filter((item, index) => {
					return (array3.indexOf(item) == index)
				})
				setHiddenAll({ ...hiddenAll, 'hidden': array3 })
				
				console.log("newValif22", array3, hiddenAll)
		
			} else if(value!=='') {
let array3 = [...hiddenAll['hidden'], ...hiddField];
				array3 = hiddenAll['hidden'].filter((item, index) => {
					return (hiddField.indexOf(item) !== index)
				})
				console.log("newValelse22", array3)
				setHiddenAll({ ...hiddenAll, ['hidden']: array3 })

			}
		}else{
		if(innerHiddenAlways && value){
		
      // console.log(innerHiddenAlways,field,value)
				const innerHiddenAlways2 = field.options?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value])?Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]):Object.values(newCaptureCond).find(o =>o.field_value[0] ===value):Object.values(newCaptureCond).find(o =>o.field_value[0] ===field.options[value]);
				console.log("innerHiddenAlways2",innerHiddenAlways2,field,value,Object.values(innerHiddenAlways.condition))
				if(innerHiddenAlways2 && hiddField){
			
				let array3 = [...hiddenAlways, ...hiddField];
			
				 array3 = array3.filter((item,index)=>{
					return (array3.indexOf(item) == index)
				 })
         console.log("if",array3)
				 setHiddenAll({...hiddenAll,['hidden']:array3})
         
				
				}else{
					setHiddenAll({...hiddenAll,['hidden']:hiddenAlways})
					// setHiddenAll(hiddenAlways)
					console.log("elssssse",hiddenAll)

				}
			}
		}
		}

  }

// useEffect(()=>{
//   console.log("useeffect hidden all",hiddenAll);
// },[hiddenAll])
  const handleChange = (event, newValue) => { setValue(newValue); };
  const addToFav = async (recordId, module, is_favs) => {
    const res = await addToFavouriteRecord(recordId, module, is_favs);
    if (res.ok) {
      setIsFav((is_favs === 1) ? 0 : 1);
      toast(res.data.data.message); return;
    }
  };

  const handleOpenDashboardActions = () => {
    setOpenDashboardActions(openDashboardActions ? false : true);
  };

  const handleOpenQuickCreateDialog = (actionName) => {
    if (actionName !== 'Emails') {
      setOpenQuickCreateDialog(!openQuickCreateDialog);
      setWhichQuickCreate(actionName);
    } else {
      dispatch(getEmailCreateView()).then(function (res) {
        // emailAsPdfAction('emailpdf')
        setEmailModal({to:recordInfo.record_email});
        setEmailModalVisible(!emailModalVisible);
      });
    }
  };
  const handleEmailPopup = (data)=>{
    //console.log("data handleEmailPopup",data);
    dispatch(getEmailCreateView());
    setEmailModal(data);
    setEmailModalVisible(data.visible);    
  }

  const DashboardActions = [];
  subpanels.map((item) => {
    if ('Activities' === item.title || 'History' === item.title) {

      item.top_buttons.map((actBtn) => {
        if (actBtn.widget_class === "SubPanelTopCreateTaskButton") {
          DashboardActions.push({ icon: <FormatListBulletedIcon />, name: 'Tasks', label: 'Create Task' })
        } else if (actBtn.widget_class === "SubPanelTopScheduleMeetingButton") {
          DashboardActions.push({ icon: <PeopleAltIcon />, name: 'Meetings', label: 'Create Meeting' })
        } else if (actBtn.widget_class === "SubPanelTopScheduleCallButton") {
          DashboardActions.push({ icon: <CallIcon />, name: 'Calls', label: 'Create Call' })
        } else if (actBtn.widget_class === "SubPanelTopComposeEmailButton") {
          DashboardActions.push({ icon: <EmailIcon />, name: 'Emails', label: 'Send Email' })
        } else if (actBtn.widget_class === "SubPanelTopCreateNoteButton") {
          DashboardActions.push({ icon: <NoteAddIcon />, name: 'Notes', label: 'Create Note' })
        }
      })

    }
  })



 console.log("statusBarData hiddenAll",hiddenAll);
  return (
    <>
      <Card className={classes.root}>
        <CardHeader
          classes={{ action: classes.cstmAction }}
          className={classes.headerCstm}
          action={
            <>
            {recordInfo.ekyc_link?
              <Tooltip title={"Initiate Video KYC"} arrow placement="bottom">
                <IconButton className={classes.favBtn} style={{margin:5}} color="primary" aria-label="upload picture" component="span" onClick={() => window.open(recordInfo.ekyc_link,"_blank")}>
                  <VideoCallIcon fontSize="large" />
                </IconButton>
              </Tooltip>:""
            }
            {
              recordInfo.download_files_link?
              <Tooltip title={"Download Files"} arrow placement="bottom">
                <IconButton className={classes.favBtn} style={{margin:5}} color="primary" aria-label="upload picture" component="span" onClick={() => window.open(recordInfo.download_files_link,"_self")}>
                  <GetAppIcon fontSize="large" />
                </IconButton>
              </Tooltip>:""
          }
              <Tooltip title={"Mark as favourite"} arrow placement="bottom">
                <IconButton className={classes.favBtn} color="primary" aria-label="upload picture" component="span" onClick={() => addToFav(recordId, module, is_favs)}>
                  {(parseInt(is_favs) === 1) ? <StarRateIcon fontSize="large" /> : <StarBorderIcon fontSize="large" />}
                </IconButton>
              </Tooltip>
              
              <MoreActionButton actionButtons={actionButtons} label="Action" module={module} view="detailview" record={recordId} />
              
            </>
          }
          title={recordInfo.record_name || ""}
          subheader={<Typography component={'span'} variant="subtitle2" className={classes.breadCrumbItem} onClick={() => history.push(`/app/${module}`)}>
            {moduleLabel}
          </Typography>}
        />
        {/*statusBarData.field_key ? 
          <Stepper orientation={'horizontal'}>
            {Object.keys(statusBarData.options).map((label, index) => (
    
      <StepButton className = {classes.steps}  active = {statusBarData.value === statusBarData.options[label] ? true : false} 
      style = {{ color: statusBarData.value === statusBarData.options[label] ? optionBgColor + 25 : '#d9e3f725',backgroundColor: statusBarData.value === statusBarData.options[label] ? optionBgColor + 25: '#d9e3f725'}}>
        <StepLabel icon = {false} style = {{ color: statusBarData.value === statusBarData.options[label] ? optionBgColor : '#d9e3f7'}}>{statusBarData.options[label]}</StepLabel>
      </StepButton >

    
  ))}

          </Stepper>
          :""
            */}
      </Card>
      

      <div className={classes.root}>
        
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={value}
          onChange={handleChange}
          aria-label="scrollable"

        >          
        <Tab
          label={<Tooltip title={"Detail View"} arrow placement="top"><div className={classes.tabName}>Detail View</div></Tooltip>}
          key={0}
          style={{ textAlign: "left" }}
          className={classes.tabButton}
        />
        { /*<Tab
          label={<Tooltip title={"BPM Process"} arrow placement="top"><div className={classes.tabName}>BPM Process</div></Tooltip>}
          key={1}
          style={{ textAlign: "left" }}
          className={classes.tabButton}
        /> */}
          {subpanels.map((tab, key) => (

            <Tab
              className={classes.tabButton}
              label={
                <Tooltip title={tab.title} arrow placement="top">
                  <div className={classes.tabName}>
                    {textEllipsis(tab.title, 15)} {tab.title !== 'Activities' && tab.title !== 'History' ? <Chip size="small" label={tab.data_count} /> : null}
                  </div>
                </Tooltip>
              }
              key={key + 1}
              {...a11yProps(key + 1)}
            />

          ))}
        
        </Tabs>
        <TabPanel value={value} index={0} key={0}>
          <Paper className={classes.paper}>
            {isTab ? (
            <DetailViewTab data={data} module={module} view="detailview"  hiddenAll={hiddenAll} />
            ) : (
                <DetailViewPanel
                  data={data}
                  module={module}
                  view="detailview"
                  headerBackground="true"
                  setEmailModal={(data)=>handleEmailPopup(data)}
                  recordId={recordId}
                  hiddenAll={hiddenAll}

                />
              )}

            {
              (module === 'AOR_Reports') ? (<AORReportDetail data={reportData} />) : ""
            }
          </Paper>
        </TabPanel>
        {/* <TabPanel value={value} index={1} key={1}>
          <Paper className={classes.paper}>
            <BPM
              data={data}
              module={module}
              view="detailview"
              headerBackground="true"
              setEmailModal={(data)=>handleEmailPopup(data)}
              recordId={recordId}
            />
          </Paper>
          </TabPanel> */}
        {subpanels.map((tab, num) => (
          <TabPanel
            value={value}
            index={num + 1}
            key={num + 1}
            style={{ width: "100%" }}
          >
            <SubPanelListView
              module={module}
              subpanel={tab.rel_module}
              subpanel_module={tab.module_name}
              title={tab.title}
              record={recordId}
              setIsSubpanelUpdated={setIsSubpanelUpdated}
              value={value}
              setValue={setValue}
            />

          </TabPanel>
        ))}
        
      </div>
      {openQuickCreateDialog ? <QuickCreate openQuickCreateDialog={openQuickCreateDialog} setOpenQuickCreateDialog={setOpenQuickCreateDialog} whichQuickCreate={whichQuickCreate} parent_name={recordInfo.record_name || ""} parent_id={recordId} parent_type={module} setIsSubpanelUpdated={setIsSubpanelUpdated}
        value={value}
        setValue={setValue} /> : null}
      {emailModalVisible && !emailCreateViewLoading ? (<QuickComposeEmail
        modalState={emailModalVisible} to_addrs_names={(emailModal && emailModal.to)?emailModal.to:''} parent_name={{ 'parent_name': recordInfo.record_name ||"", 'parent_id': recordId, 'parent_type': module }}
        handleClose={() => { setEmailModalVisible(!emailModalVisible); }}
      />) : null}
      {DashboardActions.length? <SpeedDial
        ariaLabel="Detailview Actions"
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClick={handleOpenDashboardActions}
        open={openDashboardActions}
        direction={direction}
      >
        {DashboardActions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.label}
            tooltipOpen
            onClick={() => handleOpenQuickCreateDialog(action.name)}
            classes={classesSpeedDialAction}
            TooltipClasses={classesSpeedDialAction}
          />
        ))}
      </SpeedDial>:null}
    </>
  );
}
